import store from '@/store'
import { access } from '@/configs/permissions'
import { isGasCylinderEquipmentCertificationType, statementType } from '@/configs/constants'

export const guardGasMeasurement = async (to, from, next) => {
  if (!access('gceSpecialist')) return next()

  const { statement, inspection, measurementFor } = to.query
  if (measurementFor !== statementType.certification || !statement || !inspection) {
    return next('/statements')
  }

  try {
    const document = await store.dispatch('getStatement', statement)
    if (isGasCylinderEquipmentCertificationType(document?.vehicle_condition) &&
      document.inspection && String(document.inspection) === String(inspection)) {
      return next()
    }
  } catch (error) {
    console.error(error)
  }
  return next('/statements')
}
